export default __webpack_public_path__ + "static/media/hostfully_step10.a7cd80d3.png";